



















































import { Component, Prop, Vue } from "vue-property-decorator";
import { isSlotEmpty, jamTampil, petugasNama } from "@/utility/PartografHelper";

@Component
export default class TabelObservasi extends Vue {
  @Prop({ default: () => [] }) rows!: any[];
  @Prop({ default: false }) readOnly!: boolean;
  @Prop({ default: "screen" }) variant!: string;
  @Prop({ default: false }) anchorTersimpan!: boolean;
  @Prop({ default: null }) editingIndex!: number | null;

  get bisaAksi(): boolean {
    return this.variant === "screen";
  }

  get items(): any[] {
    const src = Array.isArray(this.rows) ? this.rows : [];
    return src
      .map((row, index) => ({ row, index }))
      .filter((it) => !isSlotEmpty(it.row))
      .map((it) => this.mapRow(it.row, it.index));
  }

  mapRow(row: any, index: number) {
    return {
      index,
      jamAktual: jamTampil(row),
      jamKolom: row.jam ? String(row.jam).substr(0, 5) : "-",
      djj: this.isi(row.djj),
      serviks: this.isi(row.serviks),
      kepala: this.isi(row.kepala),
      his: this.hisText(row),
      ttv: this.ttvText(row),
      ketuban: this.ketubanText(row),
      petugas: petugasNama(row),
    };
  }

  isi(val: any): string {
    return val === null || val === undefined || String(val).trim() === "" ? "-" : String(val);
  }

  hisText(row: any): string {
    const his = row.his || {};
    const k = his.kontraksi;
    const d = his.durasi;
    if (!k && !d) return "-";
    const kontraksi = k ? k + "x" : "-";
    const durasi = d ? d + '"' : "-";
    return kontraksi + " / " + durasi;
  }

  ttvText(row: any): string {
    const tv = row.tv || {};
    const td = tv.sistole || tv.diastole ? this.isi(tv.sistole) + "/" + this.isi(tv.diastole) : "";
    const nadi = tv.nadi ? "N " + tv.nadi : "";
    const suhu = row.suhu ? "S " + row.suhu : "";
    const parts = [td, nadi, suhu].filter((p) => p !== "");
    return parts.length ? parts.join(" · ") : "-";
  }

  ketubanText(row: any): string {
    const parts = [row.air_ketuban, row.moulase].filter((p) => p !== null && p !== undefined && String(p) !== "");
    return parts.length ? parts.join(" / ") : "-";
  }
}
